/**
 * LINE の custom_token をガードより先に消費する。
 * メール変更の再認証中は既ログインでも signInWithCustomToken し、basicinfo へ戻す。
 */
import { getFirebaseAuth, signInWithCustomToken } from '@/infra/firebase/auth'
import {
  clearEmailChangePending,
  readEmailChangePending,
  writeEmailChangeAccountMismatch
} from '@/utils/auth/emailChangePending'

export type ConsumeLineCustomTokenInput = {
  isLoggedIn: boolean
  path: string
  customToken: unknown
  hintAuthMethod: (method: string) => void
  clearAuthMethodHint: () => void
}

export type ConsumeLineCustomTokenResult = {
  isLoggedIn: boolean
  redirectPath?: string
  uid?: string
}

function tokenString(customToken: unknown): string {
  if (Array.isArray(customToken)) return String(customToken[0] || '')
  return String(customToken || '')
}

export async function consumeLineCustomToken(
  input: ConsumeLineCustomTokenInput
): Promise<ConsumeLineCustomTokenResult> {
  const token = tokenString(input.customToken)
  if (input.path !== '/mypage' || !token) {
    return { isLoggedIn: input.isLoggedIn }
  }

  const pending = readEmailChangePending()
  if (input.isLoggedIn && !pending) {
    return { isLoggedIn: input.isLoggedIn }
  }

  try {
    input.hintAuthMethod('line')
    const credential = await signInWithCustomToken(getFirebaseAuth(), token)
    const signedIn = !!(credential && credential.user)
    if (!signedIn) {
      return { isLoggedIn: false }
    }

    if (pending) {
      if (credential.user.uid !== pending.uid) {
        clearEmailChangePending()
        writeEmailChangeAccountMismatch()
      }
      return {
        isLoggedIn: true,
        redirectPath: '/mypage/basicinfo',
        uid: credential.user.uid
      }
    }

    return { isLoggedIn: true, uid: credential.user.uid }
  } catch (err) {
    console.error('signInWithCustomToken failed in router guard:', err)
    input.clearAuthMethodHint()
    return { isLoggedIn: input.isLoggedIn }
  }
}
